const accessBlockedTranslations = {
    es: {
        financial:{
            title:'Regularización de pago',
            subtitle:'',
            description: 'Se ha detectado un desconocimiento de pago en tu cuenta. Para continuar, es necesario que regularices esta situación. Por favor, comunícate con nuestro equipo administrativo a través de ',
            actions:{
                primary:{
                    label: 'Ir a pagos'
                }
            }
        },
        default:{
            title:'Estas sancionado.',
            subtitle:'No tienes permisos para realizar esta acción',
            description: 'Ponte en contacto con el equipo de <span class="text-uppercase">{theme}</span> para más información.'
        }
    },
  
    en: {
     
    }
  };
  
  export default accessBlockedTranslations